import { createFileRoute } from "@tanstack/react-router";
import { AgentsWorkbenchLayout } from "@/components/agents/agents-workbench";
import { useAgents, useWorkspaceRoot } from "@/lib/api";

export const Route = createFileRoute("/$owner/agents/$agentId")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
		void queryClient.prefetchQuery(useAgents.queryOptions(params.owner));
	},
	component: AgentLayoutRoute,
});

function AgentLayoutRoute() {
	const { owner, agentId } = Route.useParams();
	return <AgentsWorkbenchLayout owner={owner} agentId={agentId} />;
}
